import {get} from './baseRequestService';

export default {
  getDashboard: (jwtToken) => {
    return get(`/v1/dashboard/`, jwtToken);
  },
};
